<template>
  <pt-report-unscramble-apply-list class="pt-report-unscramble-apply-list__page"></pt-report-unscramble-apply-list>
</template>

<script>
import PtReportUnscrambleApplyList from 'cps/lab-order/pt-report-unscramble-apply-list/withData'
export default {
  name: 'pt-report-unscramble-apply-list__view',
  components: {
    'pt-report-unscramble-apply-list': PtReportUnscrambleApplyList
  }
}
</script>
